import React from "react";
import styles from "./BadgeSVG.module.scss";

interface BadgeProps {
    text: string;
    backgroundColor?: string;
    color?: string;
}

const Badge: React.FC<BadgeProps> = ({ text, backgroundColor, color }) => {
    const radius = 70;

    // Add # prefix if not present
    const formattedBgColor = backgroundColor && !backgroundColor.startsWith("#") ? `#${backgroundColor}` : backgroundColor;
    const formattedColor = color && !color.startsWith("#") ? `#${color}` : color;

    return (
        <div className={styles.badge_wrapper}>
            <svg
                width="235"
                height="235"
                viewBox="0 0 235 235"
                xmlns="http://www.w3.org/2000/svg"
                className={styles.badge}
            >
                {/* Outer Shape */}
                <path
                    d="M112.545 6.87418C115.453 9.16113 120.215 9.16113 123.123 6.87418L128.178 2.90231C131.086 0.61536 135.281 1.17048 137.501 4.12984L141.356 9.2745C143.576 12.2338 148.174 13.4692 151.575 12.011L157.486 9.48169C160.887 8.02742 164.796 9.64588 166.172 13.0822L168.564 19.0478C169.94 22.4841 174.065 24.8609 177.724 24.3371L184.088 23.4223C187.747 22.8985 191.105 25.4708 191.547 29.1456L192.313 35.5295C192.755 39.2042 196.121 42.5701 199.791 43.008L206.175 43.7742C209.85 44.216 212.422 47.5741 211.898 51.2332L210.988 57.5975C210.464 61.2606 212.844 65.381 216.277 66.7571L222.246 69.1496C225.678 70.5257 227.301 74.435 225.843 77.8361L223.313 83.747C221.859 87.1481 223.091 91.7493 226.05 93.9659L231.194 97.8205C234.154 100.041 234.709 104.236 232.422 107.144L228.45 112.199C226.163 115.108 226.163 119.869 228.45 122.778L232.422 127.832C234.709 130.741 234.154 134.936 231.194 137.156L226.05 141.011C223.087 143.227 221.859 147.825 223.313 151.23L225.843 157.14C227.297 160.542 225.678 164.451 222.246 165.831L216.277 168.223C212.844 169.599 210.464 173.724 210.988 177.383L211.898 183.743C212.422 187.406 209.85 190.764 206.175 191.206L199.791 191.972C196.117 192.414 192.751 195.78 192.313 199.455L191.547 205.839C191.105 209.514 187.747 212.086 184.088 211.562L177.724 210.647C174.061 210.123 169.94 212.5 168.564 215.937L166.172 221.902C164.796 225.338 160.887 226.957 157.486 225.503L151.575 222.973C148.174 221.519 143.576 222.751 141.356 225.71L137.501 230.855C135.281 233.814 131.086 234.369 128.178 232.082L123.123 228.11C120.215 225.827 115.453 225.827 112.545 228.11L107.49 232.082C104.582 234.365 100.387 233.814 98.1665 230.855L94.312 225.71C92.0955 222.751 87.4982 221.515 84.0932 222.973L78.1824 225.503C74.7814 226.957 70.8722 225.338 69.4961 221.902L67.1036 215.937C65.7276 212.5 61.6072 210.123 57.9443 210.647L51.58 211.562C47.917 212.086 44.559 209.514 44.1212 205.839L43.3549 199.455C42.9132 195.78 39.5473 192.418 35.8766 191.972L29.4927 191.206C25.8181 190.764 23.2419 187.406 23.7696 183.743L24.6805 177.383C25.2043 173.72 22.8275 169.599 19.3912 168.223L13.4218 165.831C9.9895 164.455 8.37107 160.546 9.82531 157.14L12.3507 151.23C13.8049 147.828 12.5735 143.231 9.61421 141.011L4.46963 137.156C1.51033 134.936 0.955218 130.741 3.24213 127.832L7.21393 122.778C9.50084 119.869 9.50084 115.108 7.21393 112.199L3.24995 107.152C0.963037 104.244 1.51815 100.049 4.47745 97.8283L9.62203 93.9737C12.5813 91.7572 13.8167 87.1598 12.3585 83.7548L9.83313 77.8439C8.37888 74.4428 9.99731 70.5335 13.4296 69.1574L19.3991 66.7649C22.8353 65.3888 25.2121 61.2645 24.6883 57.6054L23.7774 51.241C23.2536 47.578 25.8298 44.2238 29.5006 43.782L35.8844 43.0158C39.5591 42.5741 42.9249 39.2081 43.3628 35.5373L44.129 29.1534C44.5707 25.4786 47.9249 22.9024 51.5878 23.4301L57.9521 24.3449C61.615 24.8688 65.7354 22.488 67.1115 19.0556L69.5039 13.09C70.88 9.6537 74.7892 8.03524 78.1903 9.48951L84.1011 12.0188C87.5021 13.4731 92.0994 12.2417 94.3198 9.28231L98.1744 4.13765C100.395 1.1783 104.589 0.623178 107.498 2.91013L112.545 6.87418Z"
                    fill={formattedBgColor || "#223d34"}
                />

                <defs>
                    <path
                        id="textCircle"
                        d={`M117.5,117.5 m-${radius},0 a${radius},${radius} 0 1,1 ${radius * 2},0 a${radius},${radius} 0 1,1 -${radius * 2},0`}
                    />
                </defs>

                <g className={styles.reverse_spin}>
                    {/* Top Text */}
                    <text
                        fontSize="19"
                        textAnchor="start"
                        fill={formattedColor || "#F4F2E9"}
                        fontFamily="sans-serif"
                        fontWeight={700}
                        letterSpacing="2px"
                    >
                        <textPath
                            href="#textCircle"
                            startOffset="50%"
                        >
                            {text}
                        </textPath>
                    </text>

                    {/* Bottom Text */}
                    <text
                        fontSize="19"
                        fill={formattedColor || "#F4F2E9"}
                        fontFamily="sans-serif"
                        fontWeight={700}
                        letterSpacing="2px"
                    >
                        <textPath
                            href="#textCircle"
                            startOffset="0%"
                        >
                            {text}
                        </textPath>
                    </text>
                </g>
            </svg>
        </div>
    );
};

export default Badge;
